jQuery(document).ready(function onProductPopupContactReady($) {

    // Show contact form when user scrolls past the CTA section
    if ($('#show_cta').length) {
        $(document).on('scroll.product_contact', function () {
            "use strict";
            var hT = $('#show_cta').offset().top,
                hH = $('#show_cta').outerHeight(),
                wH = $(window).height(),
                wS = $(this).scrollTop();
            if (wS > (hT + hH - wH)) {
                $('.product__contact').fadeIn();
            } else {
                $('.product__contact').fadeOut();
            }
        });
    }

    // Toggle landing page popup on mobile tap
    $('.popup_mobile').on('click', function () {
        $('.popupconent').toggle();
    });

    // Calendly modal
    var $modal = $('#calendly-modal');

    function openCalendlyModal(url) {
        $modal.find('.calendly-modal__iframe').attr('src', url);
        $modal.attr('aria-hidden', 'false').addClass('is-open');
        $('body').addClass('calendly-modal-open');
    }

    function closeCalendlyModal() {
        $modal.attr('aria-hidden', 'true').removeClass('is-open');
        $('body').removeClass('calendly-modal-open');
        // Clear iframe src to stop any ongoing requests
        $modal.find('.calendly-modal__iframe').attr('src', '');
    }

    $('#cta_calendly').on('click', function (e) {
        e.preventDefault();
        var url = $(this).data('calendly-url');
        openCalendlyModal(url);
    });

    $('[data-calendly-close]').on('click', closeCalendlyModal);

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && $modal.hasClass('is-open')) {
            closeCalendlyModal();
        }
    });

});
